import React from "react";
import { TEAL } from "./constants";

export default function ImageSlotEl({ el }) {
  const w = el.w || 260;
  const h = el.h || 260;
  const current = (el.options || [])[el.index || 0];

  return (
    <g>
      <rect x={el.x} y={el.y} width={w} height={h} rx={10}
        fill="rgba(255,255,255,0.6)" stroke={TEAL} strokeWidth={1.5}
        strokeDasharray={current ? "0" : "8 6"} />

      {current && (
        <image href={current} x={el.x + 6} y={el.y + 6}
          width={w - 12} height={h - 12} preserveAspectRatio="xMidYMid slice" />
      )}

      {!current && !el.busy && (
        <text x={el.x + w / 2} y={el.y + h / 2} textAnchor="middle" dominantBaseline="central"
          fontSize={12} fill="#94A3B8" fontFamily="'DM Sans', sans-serif">
          Describe what you want
        </text>
      )}

      {el.busy && (
        <text x={el.x + w / 2} y={el.y + h / 2} textAnchor="middle" dominantBaseline="central"
          fontSize={12} fill={TEAL} fontFamily="'DM Sans', sans-serif">
          Generating…
        </text>
      )}

      {el.error && (
        <text x={el.x + w / 2} y={el.y + h - 14} textAnchor="middle"
          fontSize={10} fill="#EF4444" fontFamily="'DM Sans', sans-serif">
          {el.error.length > 46 ? `${el.error.slice(0, 44)}…` : el.error}
        </text>
      )}
    </g>
  );
}
